import React, { JSX } from 'react';
import { Link } from 'react-router-dom';
import Style from './Button.module.scss';

type Props = {
  text: string;
  path: string;
};

const Button: React.FC<Props> = ({ text, path }): JSX.Element => {
  return (
    <div className={Style.wrapper}>
      <Link to={path} className={Style.button}>
        {text}
      </Link>
    </div>
  );
};

export default Button;
